<template>
  <div class="fundsPass">
    <div>
      <van-nav-bar
        @click-left="navTo('/account')"
        @click-right="navTo('/')"
        fixed
        placeholder
        :title="$t('account.pass')"
      >
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
        <template #right>
          <van-icon color="#000" name="wap-home-o" />
        </template>
      </van-nav-bar>
    </div>

    <van-form>
      <div v-show="show" class="content-section" style="margin-top: 10px">
        <van-field
          v-model="form.oldPassword"
          type="password"
          name="old password"
          label=""
          placeholder="old password"
          :rules="[
            { required: true, message: 'Please enter the old password' },
          ]"
        />
      </div>
      <div class="content-section" style="margin-top: 10px">
        <van-field
          v-model="form.newPassword"
          type="password"
          name="new password"
          label=""
          placeholder="new password"
          :rules="[
            { required: true, message: 'Please enter the new password' },
          ]"
        />
      </div>
      <div class="content-section" style="margin-top: 10px">
        <van-field
          v-model="confirmPassword"
          type="password"
          name="confirm password"
          label=""
          placeholder="confirm password"
          :rules="[{ required: true, message: 'Please confirm new password' }]"
        />
      </div>
      <!-- <div class="content-section" style="margin-top: 10px">
        <van-row>
          <van-col span="16">
            <van-field
              v-model="captcha.code"
              name=""
              label=""
              placeholder="Please enter the verification code"
              style="margin: 0 auto"
            />
          </van-col>
          <van-col span="8">
            <van-image
              width="100"
              height="48"
              :src="captcha.img"
              @click="changeCaptcha"
            />
          </van-col>
        </van-row>
      </div> -->
      <div style="margin: 16px">
        <van-button
          @click="accountClick"
          round
          block
          type="info"
          native-type="submit"
          >{{ $t('button.account') }}</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { captcha, submitAccount } from "@/common/api/api";

export default {
  name: "fundsPass",
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
      },
      confirmPassword: "",
      captcha: {
        img: "",
        key: "",
        code: "",
      },
      userInfo: {},
      show: false,
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    if (this.userInfo.account) {
      this.show = true;
    }
    // this.getCaptcha();
  },
  methods: {
    navTo(path) {
      this.$router.push(path);
    },
    onSubmit() {},
    changeCaptcha() {
      this.getCaptcha();
    },
    getCaptcha() {
      captcha().then((res) => {
        // console.log("captcha", res);
        this.captcha.img = res.data;
        this.captcha.key = res.key;
      });
    },
    accountClick() {
      if (this.form.newPassword != this.confirmPassword) {
        this.$toast.fail({
          duration: 5000,
          message: "Two passwords are inconsistent",
        });
        return;
      }
      const accountInfo = {
        account: "",
        oldPassword: this.form.oldPassword,
        accountPassword: this.form.newPassword,
        code: this.captcha.code,
        key: this.captcha.key,
        userId: this.userInfo.userId,
      };
      submitAccount(accountInfo)
        .then((res) => {
          if (res.code == 20011) {
            this.$toast.fail({
              duration: 5000,
              message: "Verification code error",
            });
            return;
          }
          if (res.code == 20010) {
            this.$toast.fail({
              duration: 5000,
              message: "Old password is wrong",
            });
            return;
          }
          this.form = {
            oldPassword: "",
            newPassword: "",
          };
          this.confirmPassword = "";
          this.captcha.code = "";
          this.$router.push('/')
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
.content-section {
  border: 1px solid #eee;
  border-radius: 4px;
  margin: 0 10px 10px 10px;
}
</style>
